import styled from '@emotion/styled'

const InputLabel = styled.span(({theme}) => ({
	...theme.baseStyles.inputLabel,
}))

const ValueLabel = styled.span(({theme}) => ({
	fontWeight: 600,
}))

interface L1InputLabelProps {
	label: string
	value?: string
}

const L1InputLabel = ({label, value}: L1InputLabelProps) => {
	return (
		<div>
			<InputLabel>{label}</InputLabel>
			{value ? (
				<>
					<br/>
					<ValueLabel>{value}</ValueLabel>
				</>
			) : null}
		</div>
	)
}

export default L1InputLabel
